module.exports = __webpack_public_path__ + "img/8.2cb46d34.png";